module.exports = __webpack_public_path__ + "static/media/tony-1.f2c22ccc.jpg";